import { useAnalytics, useTenant } from '@parcel2go/npm-p2g-app';
import useSWR from 'swr';
import { authenticatedFetchWithTenantAnalytics } from '~/lib/fetch';
import { captureWarning } from '~/lib/metrics';
import { GetTrackingResponse } from '~/lib/types/tracking-types';
import { useAuth } from 'react-oidc-context';
import { TRACKING_EDGE_API } from '~/lib/constants';

export default function useTracking({
  trackingReference,
  postcode,
  mostRecent
}: {
  trackingReference: string | null | undefined;
  postcode: string | null | undefined;
  mostRecent: boolean | null | undefined;
}) {
  const { session } = useAnalytics();
  const { user } = useAuth();
  const { tenant, settings } = useTenant();

  const { data, isLoading, error } = useSWR<GetTrackingResponse>(
    trackingReference
      ? `${TRACKING_EDGE_API}/${tenant}/tracking/${encodeURIComponent(trackingReference)}?postcode=${encodeURIComponent(postcode || '')}&findMostRecentParcelTracking=${mostRecent ? 'true' : 'false'}`
      : null,
    (url: string) =>
      authenticatedFetchWithTenantAnalytics(user, tenant, settings, session, url)
        .then((res) => res.json())
        .catch(() => captureWarning('Failed to fetch tracking', { section: 'tracking' })),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      dedupingInterval: 60000 // Deduplicate requests for 60 seconds to reduce load
    }
  );

  return {
    tracking: data?.result,
    isLoading,
    error
  };
}
